import api from './api/api'
export default {
    setLocalStore (key,data) {
        window.localStorage.setItem(key,JSON.stringify(data));
    },
    getLocalStore (key) {
        return JSON.parse(window.localStorage.getItem(key));
    },
    //获取关系列表
    getRelations(){
        var list = this.getLocalStore('relations')
        return new Promise((resolve,reject)=>{
            if(list && list.length){
                resolve(list)
            }else{
                api.getRelations().then(res =>{
                    resolve(res)
                    this.setLocalStore('relations',res)
                }).catch(error =>{
                    reject(error)
                })
            }
        })
    },
    //获取性别列表
    getSexs(){
        var list = this.getLocalStore('sexs')
        return new Promise((resolve,reject)=>{

            if(list && list.length){
                resolve(list)
            }else{
                api.getSexs().then(res =>{
                    resolve(res)
                    this.setLocalStore('sexs',res)
                }).catch(error =>{
                    reject(error)
                })
            }
        })

    }
}